import { connect } from 'react-redux';
import { compose } from 'redux';
import { generatePath, withRouter } from 'react-router-dom';
import { parseLocation } from 'automation-ui-routing/utils';
import { revertStagedChanges } from 'automation-ui-canvas/actions/FlowActions';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import { ActionCardOptions } from 'automation-ui-canvas/components/action-card-options/constants/ActionCardOptions';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { CANVAS_ROOT } from 'automation-ui-canvas/constants/AbsolutePaths';
import { getScreenForFlowType } from 'automation-ui-canvas/utils/getScreenForFlowType';
import { buildSearchStringWithCurrentSourceFields } from 'automation-ui-canvas/utils/routingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MoveActionPanelHeader = ({
  history,
  match,
  revertChanges,
  location,
  flowType
}) => {
  const {
    flowId
  } = match.params;
  const parsedQuery = parseLocation(location);
  const {
    operation,
    moveAllChildren
  } = parsedQuery;
  let headingLangKey;
  if (operation === ActionCardOptions.CLONE) {
    if (moveAllChildren) {
      headingLangKey = 'automation.moveActionCanvas.cloneAllHeader';
    } else {
      headingLangKey = 'automation.moveActionCanvas.cloneHeader';
    }
  } else {
    if (moveAllChildren) {
      headingLangKey = 'automation.moveActionCanvas.moveAllHeader';
    } else {
      headingLangKey = 'automation.moveActionCanvas.moveHeader';
    }
  }
  const screen = getScreenForFlowType(flowType);
  const search = buildSearchStringWithCurrentSourceFields({
    location
  });
  const pathname = generatePath(CANVAS_ROOT, {
    flowId,
    screen
  });
  return /*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: () => {
        revertChanges();
        history.replace({
          pathname,
          search
        });
      }
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: headingLangKey
      })
    })]
  });
};
export default compose(withRouter, connect(null, {
  revertChanges: revertStagedChanges
}))(MoveActionPanelHeader);